// SageDraft Landing Page (React + Tailwind)

export default function LandingPage() {
  return (
    <div className="min-h-screen bg-white text-gray-900 flex flex-col items-center">
      {/* Hero Section */}
      <section className="w-full flex flex-col items-center justify-center text-center px-6 py-20 bg-gradient-to-b from-blue-100 to-white">
        <h1 className="text-4xl md:text-6xl font-bold mb-4">Write like you. Think like you. But faster.</h1>
        <p className="text-lg md:text-xl mb-6 max-w-2xl">
          SageDraft is your personalized AI writing agent. It learns your voice and drafts emails with your tone in seconds.
        </p>
        <form
          action="https://formspree.io/f/xyzebywd"
          method="POST"
          className="flex flex-col items-center w-full max-w-sm"
        >
          <input
            type="email"
            name="email"
            required
            placeholder="Enter your email"
            className="px-4 py-2 rounded-lg border shadow-sm w-full mb-4"
          />
          <button
            type="submit"
            className="bg-blue-600 text-white px-6 py-2 rounded-lg hover:bg-blue-700 transition"
          >
            Get Early Access
          </button>
        </form>
      </section>

      {/* Problem + Solution */}
      <section className="w-full px-6 py-16 bg-white text-center">
        <h2 className="text-3xl font-semibold mb-4">Tired of rewriting the same email?</h2>
        <p className="text-lg max-w-3xl mx-auto">
          SageDraft learns from your previous writing and drafts personalized content so you never start from scratch again.
        </p>
      </section>

      {/* How It Works */}
      <section className="w-full bg-gray-50 py-16 px-6">
        <h2 className="text-3xl font-semibold text-center mb-10">How It Works</h2>
        <div className="grid md:grid-cols-3 gap-6 max-w-5xl mx-auto">
          <div className="bg-white p-6 rounded-2xl shadow-md">
            <h3 className="text-xl font-bold mb-2">1. Upload Your Writing</h3>
            <p>Send us 3–5 of your old emails or notes. We’ll learn your voice.</p>
          </div>
          <div className="bg-white p-6 rounded-2xl shadow-md">
            <h3 className="text-xl font-bold mb-2">2. Define Your Style</h3>
            <p>Answer a few onboarding questions to guide the tone engine.</p>
          </div>
          <div className="bg-white p-6 rounded-2xl shadow-md">
            <h3 className="text-xl font-bold mb-2">3. Generate Drafts</h3>
            <p>Type what you need. SageDraft returns ready-to-send content.</p>
          </div>
        </div>
      </section>

      {/* Testimonials Placeholder */}
      <section className="w-full py-16 px-6 text-center">
        <h2 className="text-3xl font-semibold mb-4">What Early Users Say</h2>
        <p className="italic text-gray-500">Coming soon – real feedback from our first believers.</p>
      </section>

      {/* Footer */}
      <footer className="w-full bg-gray-100 py-6 text-center text-sm text-gray-500">
        <p>&copy; 2025 SageDraft. All rights reserved.</p>
        <p className="mt-2">Built with 💛 by Sunny & Mon Ami</p>
      </footer>
    </div>
  );
}
